import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Subcompany from "../../models/asset-subtype";

const RECORS_PER_SEARCH = 20;

type SubcompanieselectProps = {
  value: Subcompany | null;
  disabled?: boolean;
  onChange: (_: Subcompany | null) => void;
};

const SubcompanySelect: React.FC<SubcompanieselectProps> = ({
  value,
  disabled,
  onChange,
}) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (
      | Subcompany
      | { options: Subcompany[]; label?: string }
    )[]
  ): Promise<
    Response<Subcompany, { options: Subcompany[]; label?: string }, any>
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<Subcompany>(
      "/subcompanies/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: Subcompany[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Selecccione Sub organización"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: Subcompany) => `${option.name}`}
      getOptionValue={(option: Subcompany) => `${option.id}`}
      value={value}
      isDisabled={disabled}
      isClearable={true}
    />
  );
};

export default SubcompanySelect;
